<template>
  <div class="app-container" ref="body">
    <div class="app-body">
      <van-nav-bar
        title="快速报名"
        left-text="返回"
        left-arrow
        fixed
        class="fixedapp"
        @click-left="$router.replace('/')"
      >
        <template #right>
          <div v-if="!form.id">
            <a href="javascript:;" class="clear-btn" @click="doClear">一键清空</a>
          </div>
        </template>
      </van-nav-bar>
      <div class="form-info" style="padding-top:3.6rem;">
        <van-form @submit="onSubmit" @failed="onFailed" ref="form">
          <van-cell-group title="个人信息">
            <van-field
              v-model="form.name"
              name="name"
              label="姓名"
              placeholder="姓名"
              required
              :rules="[{ required: true, message: '请填写姓名' }]"
            />
            <van-field name="sex" label="性别"
              required
              :rules="[{ required: true, message: '请选择性别' }]"
            >
              <template #input>
                <van-radio-group v-model="form.sex" direction="horizontal">
                  <template v-for="item in sexList">
                    <van-radio v-if="item.id != '03'" :key="item.id" :name="item.id">{{ item.name }}</van-radio>
                  </template>
                </van-radio-group>
              </template>
            </van-field>
            <van-field
              type="number"
              v-model="form.mobile"
              name="mobile"
              label="手机号"
              placeholder="手机号"
              required
              :rules="[{ required: true, pattern:/^1[3456789]\d{9}$/, message: '请填写正确的手机号' }]"
            />
            <van-field
              v-model="form.sfzh"
              name="sfzh"
              label="身份证号"
              placeholder="身份证号"
              :rules="[{ required: false, validator: (value, rule) => {
                  if (value) {
                    let m = value.match(/^[1-9]\d{5}(?:18|19|20)\d{2}(?:0[1-9]|10|11|12)(?:0[1-9]|[1-2]\d|30|31)\d{3}[\dXx]$/);
                    return m ? true : false;
                  }
                  return true
                }, 
                //pattern:/^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/
                message: '请填写正确的身份证号' }]"
            />
            <van-field
              v-model="form.weixin"
              name="weixin"
              label="微信号"
              placeholder="微信号"
              :rules="[{ required: false, message: '请填写微信号' }]"
            />
            <!-- <van-field
              type="number"
              v-model="form.qq"
              name="qq"
              label="QQ"
              placeholder="QQ号"
              :rules="[{ required: false, pattern:'', type:'integer', message: '请填写QQ号' }]"
            /> -->
          </van-cell-group>
          <van-cell-group title="报名学籍">
            <van-field
              readonly
              clickable
              name="picker"
              :value="form.xjname"
              label="学籍类型"
              placeholder="点击选择学籍类型"
              required
              @click="showXj = true"
              :rules="[{ required: true, message: '请选择学籍类型' }]"
            />
            <van-popup v-model="showXj" position="bottom" class="fixedapp">
              <van-picker
                show-toolbar
                :columns="xjList"
                :default-index="xjList.findIndex(d => d.id == form.xjid)"
                value-key="name"
                @change="onChangeXj"
                @confirm="onConfirmXj"
                @cancel="showXj = false"
              />
            </van-popup>
            <van-field
              readonly
              clickable
              name="picker"
              :value="form.yxname"
              label="院校"
              placeholder="点击选择院校"
              @click="showYx = true"
              :rules="[{ required: false, message: '请选择院校' }]"
            />
            <van-popup v-model="showYx" position="bottom" class="fixedapp">
              <van-picker
                show-toolbar
                :columns="yxList"
                :default-index="yxList.findIndex(d => d.id == form.yxid)"
                value-key="name"
                @confirm="onConfirmYx"
                @cancel="showYx = false"
              />
            </van-popup>
            <van-field
              readonly
              clickable
              name="picker"
              :value="form.ccname"
              label="层次"
              placeholder="点击选择层次"
              required
              @click="showCc = true"
              :rules="[{ required: true, message: '请选择层次' }]"
            />
            <van-popup v-model="showCc" position="bottom" class="fixedapp">
              <van-picker
                show-toolbar
                :columns="ccList"
                :default-index="ccList.findIndex(d => d.id == form.ccid)"
                value-key="name"
                @change="onChangeCc"
                @confirm="onConfirmCc"
                @cancel="showCc = false"
              />
            </van-popup>
            <van-field
              readonly
              clickable
              name="picker"
              :value="form.zyname"
              label="专业"
              placeholder="点击选择专业"
              @click="showZy = true"
              :rules="[{ required: false, message: '请选择专业' }]"
            />
            <van-popup v-model="showZy" position="bottom" class="fixedapp">
              <van-picker
                show-toolbar
                :columns="zyList1"
                :default-index="zyList1.findIndex(d => d.id == form.zyid)"
                value-key="name"
                @confirm="onConfirmZy"
                @cancel="showZy = false"
              />
            </van-popup>
            <van-field
              v-if="form.xjid == '02'"
              v-model="form.ezy"
              label="第二志愿"
              placeholder="输入第二志愿"
            />
            <van-field
              v-model="form.note"
              rows="1"
              autosize
              label="备注"
              type="textarea"
              placeholder="输入备注"
            />
            <van-field
              v-model="form.zslsname"
              label="招生老师"
              readonly
              placeholder="招生老师"
            />
          </van-cell-group>
          <div class="signup-btns">
            <!-- <div v-if="total" class="prices">
              小计：<span class="price" v-html="webPrice(total)"></span>
            </div> -->
            <van-button round block type="info" native-type="submit" :loading="saveLoading" :loading-text="saveTxt +'中...'">
              确定{{ saveTxt }}
            </van-button>
          </div>
        </van-form>
      </div>
    </div>
    <!-- 如果绑定有多个学生信息，提示选择 -->
    <van-dialog
      use-slot
      title="请选择报名学生"
      v-model="showStu"
      :show-confirm-button="false"
      show-cancel-button
      @cancel="cancelStu"
    >
      <van-cell-group style="max-height:60vh; overflow-y: auto;">
        <van-cell title="新学生报名" is-link @click="addStu()">
          <template v-slot:title>
            <div style="color:red; font-weight:bold;">新学生报名</div>
          </template>
        </van-cell>
        <van-cell v-for="item in stuList" :key="item.id" :title="item.name +' / '+ showSex(item.sex)" @click="chooseStu(item)">
          <template v-slot:label>
            <div style="display:flex;">
              <div>
                <p>身份证：{{ item.sfzh }}</p>
                <p>手机号：{{ item.mobile }}</p>
              </div>
              <div style="margin-left:auto; padding-left:1rem;">
                {{ item.rollList.length + '学籍'}}
              </div>
            </div>
          </template>
        </van-cell>
      </van-cell-group>
    </van-dialog>
  </div>
</template>

<script>
import * as types from '@/store/mutation-types';
import { mapGetters } from 'vuex';
import siteMixin from '@/utils/site-mixin';
import { deepCopy } from '@/utils/utils';
export default {
  components: {
  },
  mixins: [siteMixin],
  props: {
    xjid: String,
    zsls: String
  },
  data() {
    return {
      stuLoading: false,
      showStu: true,
      error: false,
      isLoading: false,
      showXj: false,
      showCc: false,
      showYx: false,
      showZy: false,
      stuList: {},
      form: {},
      saveLoading: false,
      lastTempTime: 0, // 上次暂存时间
      oldSignup: {},
      isSignup: false, // 是否要临存数据
    }
  },
  computed: {
    ...mapGetters({
      zslsinfo: 'zslsinfo',
      sexList: [types.BASE_LOAD.sexList],
      xjList: [types.BASE_LOAD.xjList],
      ccList: [types.BASE_LOAD.ccList],
      yxList: [types.BASE_LOAD.yxList],
      zyList: [types.BASE_LOAD.zyList],
      reloadWeb: [types.OTHER.reloadWeb],
    }),
    saveTxt() {
      return this.orderid ? '更新' : '报名';
    },
    zyList1() {
      if (!this.zyList) {
        return [];
      }
      const xjid = this.form.xjid;
      const yxid = this.form.yxid;
      const ccid = this.form.ccid;
      return this.zyList.filter(d => {
        const xj = xjid ? xjid == d.xjid : true;
        const yx = yxid && d.yxids ? d.yxids.includes(yxid) : true;
        const cc = ccid ? ccid == d.ccid : true;
        return xj && yx && cc;
      });
    },
    xjMap() {
      let map = {};
      if (!this.xjList) {
        return map;
      }
      this.xjList.forEach(d => {
        map[d.id] = d;
      });
      return map;
    },
    defaultData() {
      return {
        name: null,
        sex: null,
        sfzh: null,
        mobile: null,
        qq: null,
        weixin: null,
        xjid: null,
        xjname: null,
        ccid: null,
        ccname: null,
        yxid: null,
        yxname: null,
        zyid: null,
        zyname: null,
        bmzy: null,
        note: null,
        zslsid: this.zslsinfo.id || null,
        zslsname: this.zslsinfo.name || null,
        departid: this.zslsinfo.departid || null,
        signupid: null,
        ezy: null, // 二志愿【成教】
      }
    },
    total() {
      return 0;
    }
  },
  watch: {
    reloadWeb() {
      this.loadData();
    },
    zsls() {
      this.loadData();
    },
    form: {
      handler: function() {
        const timespace = 8000; // 间隔8秒以上暂存
        const now = Date.now();
        if (now - this.lastTempTime > timespace) {
          this.lastTempTime = now;
          this.tempSave();
        }
      },
      deep: true
    },
    zyList1: {
      handler: function(val) {
        if (!val.length) {
          this.form.zyid = null;
          this.form.zyname = null;
        }
        if (this.form.zyid) {
          if (!val.some(d => d.id == this.form.zyid)) {
            this.form.zyid = null;
            this.form.zyname = null;
          }
        }
      },
      deep: true
    }
    /*xjid() {
      this.loadData();
    }*/
  },
  // 离开本页时
  beforeRouteLeave(to, from, next) {
    // 暂存
    if (this.isSignup) {
      this.tempSave();
    }

    next();
  },
  created () {
    // resize
    let resizeId;
    window.addEventListener('resize', () => {
      clearTimeout(resizeId);
      resizeId = setTimeout(this.getImgW, 300);
    });

    // this.loadData();
    this.lastTempTime = Date.now();
  },
  activated() {
    this.loadData();
  },
  mounted () {
    this.$bus.$on('loginok', () => {
      this.loadData();
    });
  },
  methods: {
    getSignup() {
      return new Promise((resolve, reject) => {
        this.doGet({
          url: 'site/register/getSignup',
          okcb: (json) => {
            this.oldSignup = json || {};
            resolve();
          },
          cb: () => {

          },
          errcb: () => {
            reject();
          }
        });
      });
    },
    loadZsls() {
      return new Promise((resolve, reject) => {
        this.doGet({
          url: 'site/home/getZsls/'+ this.zsls.trim(),
          okcb: (json) => {
            this.$store.commit('setZslsinfo', json);
            resolve();
          },
          cb: () => {

          },
          errcb: () => {
            reject();
          }
        });
      });
    },
    async loadData() {
      // 检查登录
      this.checkLogin();
      // if (!this.member.id || !this.member.openid) {
      //   this.Toast('请先登录！');
      //   // this.$router.replace({path: '/', params:{hasLogin: Date.now() +''} })
      //   //   .catch(err => {
      //   //     console.log(err)
      //   //   });
      //   // setTimeout(() => {
      //   //   this.Toast.clear();
      //   // }, 3000);
      //   return;
      // }
      // console.log(this.zslsinfo)

      this.isSignup = false;

      if (!this.xjList || !this.xjList.length) {
        await this.$store.dispatch(types.BASE_LOAD.xjList);
      }
      if (!this.yxList || !this.yxList.length) {
        await this.$store.dispatch(types.BASE_LOAD.yxList);
      }
      if (!this.ccList || !this.ccList.length) {
        await this.$store.dispatch(types.BASE_LOAD.ccList);
      }
      if (!this.zyList || !this.zyList.length) {
        await this.$store.dispatch(types.BASE_LOAD.zyList);
      }
      if (this.zsls) {
        await this.loadZsls();
      }

      this.form = Object.assign({}, this.defaultData);

      await this.getSignup();

      this.loadStu();

      this.form = Object.assign({}, this.defaultData, {
        xjid: this.xjid,
        xjname: this.xjid ? (this.xjMap[this.xjid])?.name ?? null : null,
        zslsid: this.zslsinfo.id || null,
        zslsname: this.zslsinfo.name || null,
        departid: this.zslsinfo.departid || null
      });
      // console.log(this.form)

      if (!this.sexList || !this.sexList.length) {
        this.$store.dispatch(types.BASE_LOAD.sexList);
      }
      // if (!this.xjList || !this.xjList.length) {
      //   this.$store.dispatch(types.BASE_LOAD.xjList);
      // }
      // if (!this.ccList || !this.ccList.length) {
      //   this.$store.dispatch(types.BASE_LOAD.ccList);
      // }
      // if (!this.yxList || !this.yxList.length) {
      //   this.$store.dispatch(types.BASE_LOAD.yxList);
      // }
    },
    doClear() {
      this.Dialog.confirm({
        title: '提示',
        message: '确定要清空已填写信息吗？',
      }).then(() => {
        this.form = Object.assign({}, this.defaultData, {
          zslsid: this.form.zslsid,
          zslsname: this.form.zslsname,
          departid: this.form.departid
        });
      }).catch(() => {});
    },
    loadStu() {
      if (this.stuLoading) {
        return;
      }
      this.stuLoading = true;
      this.showStu = false;
      this.Toast.loading({
        message: '加载中...',
        forbidClick: true,
      });
      this.doGet({
        url: 'site/home/stu',
        data: {},
        okcb: (json) => {
          if (json.stuList) {
            json.stuList.map(d => {
              d.rollList = d._rolls ? JSON.parse(d._rolls) : [];
            });
          }
          this.stuList = json.stuList || [];
          this.showStu = true;

          if (!this.stuList.length) {
            this.showStu = false;
            this.addStu();
          }
        },
        cb: () => {
          this.$nextTick(() => {
            this.stuLoading = false;
            this.Toast.clear();
          });
        }
      });
    },
    cancelStu() {
      this.$router.push('/');
    },
    addStu() {
      this.showStu = false;
      // console.log(this.oldSignup, this.xjid, this.zslsinfo)
      if (!!(this.oldSignup.signupid)) {
        this.form = Object.assign({}, this.form, this.oldSignup);
        if (this.zslsinfo.id) {
          this.form.zslsid = this.zslsinfo.id;
          this.form.zslsname = this.zslsinfo.name;
          this.form.departid = this.zslsinfo.departid;
        }
        if (this.xjid) {
          let xj = this.xjList.filter(d => d.id == this.xjid);
          if (xj.length) {
            this.form.xjid = xj[0].id;
            this.form.xjname = xj[0].name;
          }
        }
      } else {
        this.form = Object.assign({}, this.form, {
          zslsid: this.zslsinfo.id || '',
          zslsname: this.zslsinfo.name || '',
          departid: this.zslsinfo.departid || ''
        });
      }
      // console.log('add,,,', this.zslsinfo)
      this.isSignup = true; // 标记临存
    },
    chooseStu(stu) {
      this.form = Object.assign({}, this.form, {
        id: stu.id,
        name: stu.name,
        sex: stu.sex,
        sfzh: stu.sfzh || '',
        mobile: stu.mobile || '',
        weixin: stu.weixin || '',
        qq: stu.qq || '',
        version: stu.version || 0
      });
      this.showStu = false;
    },
    onConfirmXj(data) {
      this.form.xjid = data.id;
      this.form.xjname = data.name;
      this.showXj = false;
    },
    onChangeXj(el, data) {
      this.onConfirmXj(data);
    },
    onConfirmCc(data) {
      this.form.ccid = data.id;
      this.form.ccname = data.name;
      this.showCc = false;
    },
    onChangeCc(el, data) {
      this.onConfirmCc(data);
    },
    onConfirmYx(data) {
      this.form.yxid = data.id;
      this.form.yxname = data.name;
      this.showYx = false;
    },
    onConfirmZy(data) {
      if (data && data.id) {
        this.form.zyid = data.id;
        this.form.zyname = data.name;
      }
      this.showZy = false;
    },
    // 上传图片
    afterRead(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      this.doUpload4Vant({
        url: this.upload4Web,
        file: file.file,
        okcb: (json) => {
          file.status = 'done';
          file.url = json.pic;

          // console.log(json, file)
          
        },
        errcb: (json) => {
          // console.log(json)
          file.status = 'failed';
          file.message = json.message || '上传失败！';
        }
      });
    },
    onSubmit(values) {
      let postData = deepCopy(this.form);
      if (postData.sfzh) {
        postData.sfzh = postData.sfzh.toUpperCase();
      }
      if (postData.zslsid) {
        postData.zsls = postData.zslsid;
      }

      // 学籍信息
      let roll = deepCopy(postData);
      delete roll.id;
      postData.roll = roll;
      // 移除无关信息
      delete postData.note;

      postData.version === null ? postData.version = 1 : (postData.version += 1);

      this.Toast.loading({
        message: '加载中...',
        forbidClick: true
      });

      this.isSignup = false;
      this.saveLoading = true;
      this.doPost({
        url: 'site/register',
        data: postData,
        okcb: (json) => {
          setTimeout(() => {
            this.Toast.success('报名成功！');
            this.$store.commit(types.OTHER.reloadWeb);
          }, 10);
          if (json.id) {
            this.$router.push('/stu-main/'+ json.id);
          }
        },
        cb: () => {
          this.saveLoading = false;
          this.Toast.clear();
        },
        errcb: (json) => {
          if (json && json.message) {
            setTimeout(() => {
              //this.Toast.fail(json.message);
              this.Dialog.alert({ message: json.message });
            }, 10);
          }
          // 如果有临存ID，需要继续临存
          if (postData.signupid) {
            this.isSignup = true;
          }
        }
      });
    },
    onFailed({ errors }) {
      if (errors.length) {
        this.$refs.form.scrollToField(errors[0].name);
      }
    },
    // 临存
    tempSave() {
      // console.error('temp...save', this.isSignup, JSON.stringify(this.form));
      // 不临存已存在的学籍
      if (this.form.id) {
        return;
      }
      // 非临存标记的，不存
      if (!this.isSignup) {
        return;
      }
      this.doPost({
        url: 'site/register/signup',
        data: this.form,
        okcb: () => {

        }
      });
    }
  }
}
</script>
<style lang="less" scoped>
.app-body {
  /deep/ .van-field--error .van-field__control::placeholder {
    color: #ccc;
  }
  /deep/ .clear-btn {
    padding: 4px 8px;
    color: tomato;
    border: 1px tomato solid;
    border-radius: 5px;
    &:hover {
      color: #fff;
      background-color: tomato;
    }
  }
}
.item-info {
  h4 {
    margin-bottom:.25rem;
    padding:0 .5rem;
    color:#888;
  }
  .detail {
    padding:.5rem .8rem;
    background-color:#fff;
  }
  .tit {
    .fontsize(1.2rem);
  }
  .con {
    margin-top:.25rem;
    color:#888;
  }
}
.form-info {
  padding-bottom:5.2rem;
  h4 {
    padding:0 .5rem;
    margin-bottom:.25rem;
    color:#888;
  }
  /deep/ .course-field {
    .van-checkbox-group,
    .van-checkbox__label {
      width:100%;
    }
  }
  /deep/ .course-item {
    .flex();
    padding:.35rem 0;
    .prices {
      margin-left: auto;
    }
    .market {
      display: inline-block;
      margin-right:.25rem;
      padding:0 .25rem;
      text-decoration: line-through;
      color:#aaa;
      small {
        .fontsize(.8rem);
      }
    }
    .price {
      display: inline-block;
      color: #ff6600;
      .fontsize(1.4rem);
      small {
        .fontsize(.85rem);
      }
    }
  }
}
.signup-btns {
  position:fixed;
  left: 50%;
  bottom: 1rem;
  width: 100%;
  max-width: 750px;
  .flex-center-v();
  transform: translateX(-50%);
  /deep/ .van-button--normal {
    .fontsize(1.2rem);
  }
  .prices {
    margin-right:2rem;
    padding:.5rem 1rem;
    white-space: nowrap;
    flex-shrink: 0;
    background-color:#f0f0f0;
    border-radius:2rem;
    .price {
      display: inline-block;
      color: #ff6600;
      .fontsize(1.2rem);
      small {
        .fontsize(.85rem);
      }
    }
  }
}
</style>